import React from 'react';

export function ChatSidePanelEmptyText({
  children,
  className = 'side-list-empty',
}) {
  return <div className={className}>{children}</div>;
}

export function ChatSidePanelEmptyCard({
  children,
  className = '',
}) {
  const cardClassName = ['side-panel-card', 'muted', className].filter(Boolean).join(' ');
  return <div className={cardClassName}>{children}</div>;
}

/**
 * サイドパネルの 1 区画。旧「浮いた角丸カード」ではなく、
 * 全幅の見出し帯（.csp-sec__head）＋本文（.csp-sec__body）で構成する
 * フラットなセクション。全チャット共通。
 *
 * @param {string} title     見出しテキスト
 * @param {ReactNode} titleNode 見出しを差し替えたい場合のノード（title より優先）
 * @param {ReactNode} count   見出し右側の件数・補助（例: 参加人数）
 * @param {ReactNode} headExtra 見出し右側の追加要素（count と併用可）
 * @param {boolean} tight     本文の行間を詰める
 */
export default function ChatSidePanelCard({
  title = '',
  titleNode = null,
  count = null,
  headExtra = null,
  tight = false,
  className = '',
  bodyClassName = '',
  children,
}) {
  const sectionClassName = ['csp-sec', className].filter(Boolean).join(' ');
  const contentClassName = ['csp-sec__body', tight ? 'csp-sec__body--tight' : '', bodyClassName]
    .filter(Boolean)
    .join(' ');
  const hasHead = Boolean(titleNode || title || count != null || headExtra);

  return (
    <section className={sectionClassName}>
      {hasHead ? (
        <div className="csp-sec__head">
          {titleNode || <span className="csp-sec__title">{title}</span>}
          {count != null || headExtra ? (
            <span className="csp-sec__count">
              {count}
              {headExtra}
            </span>
          ) : null}
        </div>
      ) : null}
      <div className={contentClassName}>{children}</div>
    </section>
  );
}
